module.exports = __webpack_public_path__ + "static/media/no-tickets.f98426b3.png";